import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=c380c5b2&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=js&"
export * from "./Details.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/project-details.scss?vue&type=style&index=0&id=c380c5b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c380c5b2",
  null
  
)

export default component.exports